export function isAdminUser(auth = {}) {
    return String(auth?.userRole?.name || "").toLowerCase() === "admin";
}

export function getPageCapability(userCapability = [], component) {
    const capability = (userCapability || []).find(item =>
        item.component === component && item.type === "page"
    );

    return capability?.permission ?? -1;
}

export function hasAssignedRuleGroup(rule = {}, auth = {}) {
    const assignedGroupIds = (auth?.groups || [])
        .map(group => String(group.id || group.pk))
        .filter(Boolean);

    if (!assignedGroupIds.length) {
        return false;
    }

    return (rule?.groups || []).some(group =>
        assignedGroupIds.includes(String(group.id || group.pk))
    );
}

export function canEditRuleDetails(rule = {}, auth = {}, component = "msbruledetails") {
    if (!canEditRuleFields(auth, component)) {
        return false;
    }

    if (!rule?.id && !rule?.pk) {
        return true;
    }

    if (isAdminUser(auth)) {
        return true;
    }

    return hasAssignedRuleGroup(rule, auth);
}

export function canEditRuleFields(auth = {}, component = "msbruledetails") {
    const capability = getPageCapability(auth?.userCapability, component);
    if (capability === 0) {
        return false;
    }

    return true;
}
